import InitialAdminContainer from './InitialAdminContainer';

export default InitialAdminContainer;
